import * as XLSX from "xlsx";

// Downloads rows as .xlsx using the table's columns (exp > value > key).
export function exportXlsx(name, columns, rows) {
  const cols = columns.filter((c) => c.label && c.exp !== false);
  const data = rows.map((r) => Object.fromEntries(cols.map((c) => {
    const v = c.exp ? c.exp(r) : c.value ? c.value(r) : r[c.key];
    return [c.label, Array.isArray(v) ? v.join(", ") : v ?? ""];
  })));
  const ws = XLSX.utils.json_to_sheet(data, { header: cols.map((c) => c.label) });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, name.slice(0, 31));
  XLSX.writeFile(wb, `${name}_${new Date().toLocaleDateString("en-CA")}.xlsx`);
}
